import PaymentClaim from './PaymentClaim';

export default PaymentClaim;
